@if (!abTestSenderOnlyMode) {
<form [formGroup]="sendingConfigForm" fxLayout="row wrap" fxLayoutAlign="space-around baseline" style="margin-bottom: 15px;">

  <p fxFlex="100" [innerHTML]="'COMMON.SOURCE_SETUP.SENDING_CONF.CONTACTS_EXPLANATION' | translate"></p>

  <mat-form-field appearance="outline" fxFlex="1 1 100%" fxFlex.gt-xs="0 0 calc(50% - 15px)">
    <mat-label>{{ 'COMMON.SOURCE_SETUP.SENDING_CONF.CONTACTS_MAILER' | translate }}</mat-label>
    <mat-select formControlName="contactsMailer">
      @for (contactsMailer of contactsMailers; track contactsMailer) {
        <mat-option [value]="contactsMailer.id">
          {{contactsMailer.displayName}}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <!-- Empty div for replacing space taken by contact list selector -->
  @if (isManualContactsMailer) {
    <div fxFlex="1 1 100%" fxFlex.gt-xs="0 0 calc(50% - 15px)"></div>
    <app-mediego-chip-multiselect
      fxFlex="1 1 100%" fxFlex.gt-xs="0 0 calc(100% - 15px)"
      label="{{ 'COMMON.SOURCE_SETUP.SENDING_CONF.MANUAL_CONTACTS_LIST' | translate }}"
      appearance="outline"
      [multiple]="false"
      (outputPatterns)="updateManualContactLists($event)"
      [preselectedPatterns]="sendingConfigForm.get('contactsLists').value"
      style="margin-top: 15px;"
    ></app-mediego-chip-multiselect>
  } @else {
    <app-mediego-multi-select
      [label]="'COMMON.SOURCE_SETUP.SENDING_CONF.CONTACTS_LISTS' | translate"
      [availableElements]="contactsListsForMailer"
      [displayWith]="displayContactsListsName"
      sortKey="name"
      [selectedElements]="sendingConfigForm.get('contactsLists').value"
      (selectedElementsChange)="updateSelectedContactsLists($event)"
      fxFlex="1 1 100%" fxFlex.gt-xs="0 0 calc(50% - 15px)"
      [disabled]="contactsMailerLoading || sendingConfigForm?.disabled || !sendingConfigForm.get('contactsMailer').value"
      [withSelectAll]="false">
    </app-mediego-multi-select>
  }
</form>

<hr/>
}

<form [formGroup]="sendingConfigForm" fxLayout="row wrap" fxLayoutAlign="space-around baseline" style="margin-bottom: 15px;">

  <p fxFlex="100" [innerHTML]="'COMMON.SOURCE_SETUP.SENDING_CONF.SENDER_EXPLANATION' | translate"></p>

  @if (!abTestSenderOnlyMode) {
    <mat-form-field appearance="outline" fxFlex="1 1 100%" fxFlex.gt-xs="0 0 calc(50% - 15px)">
      <mat-label>{{ 'COMMON.SOURCE_SETUP.SENDING_CONF.SENDING_MAILER' | translate }}</mat-label>
      <mat-select formControlName="sendingMailer">
        @for (sendingMailer of sendingMailers; track sendingMailer) {
          <mat-option [value]="sendingMailer.id">
            {{sendingMailer.displayName}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    @if (showRestrictiveMailerWarning) {
      <div class="restrictive-mailer-warning" fxFlex="1 1 100%" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
        <mat-icon color="warn">warning</mat-icon>
        <span>{{ 'COMMON.SOURCE_SETUP.SENDING_CONF.RESTRICTIVE_MAILER_AB_TEST_WARNING' | translate }}</span>
      </div>
    }
  }

  <mat-form-field appearance="outline"  fxFlex="1 1 100%" fxFlex.gt-xs="0 0 calc(50% - 15px)">
    <mat-label>{{ 'COMMON.SOURCE_SETUP.SENDING_CONF.SENDER_ADDRESS' | translate }}</mat-label>
    <mat-select formControlName="senderAddress">
      @for (sender of formattedSenders; track sender.value) {
        <mat-option [value]="sender.value">
          {{ sender.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

</form>
<form [formGroup]="sendingConfigForm" fxLayout="row wrap" fxLayoutAlign="space-around baseline" style="margin-bottom: 15px;">

  <mat-form-field appearance="outline" fxFlex="1 1 100%" fxFlex.gt-xs="0 0 calc(50% - 15px)" subscriptSizing="dynamic" [class.disabled-field]="selectedSendingMailerType === 'batch'">
    <mat-label>{{ 'COMMON.SOURCE_SETUP.SENDING_CONF.SENDER_NAME' | translate }}</mat-label>
    <input type="text" matInput formControlName="senderName">
    <button mat-icon-button matSuffix color="accent">
      <mat-icon>account_circle</mat-icon>
    </button>
    @if(selectedSendingMailerType === 'batch') {
      <mat-hint>{{ 'COMMON.SOURCE_SETUP.SENDING_CONF.SENDER_NAME_BATCH_HINT' | translate }}</mat-hint>
    }
  </mat-form-field>

  @if (!abTestSenderOnlyMode) {
    <mat-form-field appearance="outline" fxFlex="1 1 100%" fxFlex.gt-xs="0 0 calc(50% - 15px)" subscriptSizing="dynamic">
      <mat-label>{{ 'COMMON.SOURCE_SETUP.SENDING_CONF.REPLY_TO' | translate }}</mat-label>
      <input type="text" matInput placeholder="Reply to address" formControlName="replyToAddress">
      <button mat-icon-button matSuffix color="accent">
        <mat-icon>reply</mat-icon>
      </button>
    </mat-form-field>
  }
</form>

@if (!abTestSenderOnlyMode) {
  @if (specificSendingConf) {
    <form fxLayout="row wrap" fxLayoutAlign="space-around baseline" style="margin-bottom: 15px;">
      @switch (selectedSendingMailerType) {
        @case ('a7') {
          <app-mediego-specific-sending-conf-a7 [formControl]="specificSendingConf" fxFlex="1 1 100%">
          </app-mediego-specific-sending-conf-a7>
        }
        @case ('elastic-email') {
          <app-mediego-specific-sending-conf-elastic-email [formControl]="specificSendingConf" fxFlex="1 1 100%">
          </app-mediego-specific-sending-conf-elastic-email>
        }
      }
    </form>
  }

  <div fxLayout="row" fxLayoutAlign="end end">
    <button fxFlex="nogrow" mat-button color="warn" (click)="restoreConfig()" matTooltip="Nécessitera une sauvegarde pour être pris en compte">Réinitialiser la configuration</button>
  </div>
}
